import { render, staticRenderFns } from "./StoreStock.vue?vue&type=template&id=b37833be"
import script from "./StoreStock.vue?vue&type=script&lang=js"
export * from "./StoreStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports